import axios from 'axios';

const baseURL = `${process.env.REACT_APP_BASE_URL}/v1`;

export default axios.create({
  baseURL,
});
